import * as z from 'zod';

export type Options = {
  accessToken: string;
  version?: string;
};

type clipContentId = number | string;
// GET /3.0/users/me/clips
export const ContentSchema = z.object({
  id: z.custom<clipContentId>(
    (id) => typeof id === 'number' || typeof id === 'string', // コラムのみidがstring型
  ),
  title: z.string(),
  subtitle: z.string(),
  publishedAt: z.string(), // ISO 8601形式の文字列
  thumbnailURL: z.string().optional(),
});

export const CompanySchema = z.object({
  id: z.number(),
  imageURL: z.string(),
});

export const ClipSchema = z.object({
  type: z.string(),
  label: z.string(),
  content: ContentSchema,
  company: CompanySchema,
  hashtags: z.array(z.string()).nullable(),
  clipCount: z.number(),
  clippedAt: z.string(), // ISO 8601形式の文字列
});

// TODO: clipがnullの場合があるので、一旦nullを許容するがbackend側で修正する必要あり
export const UsersMeClipsResponse = z.object({
  clips: z.array(ClipSchema),
  nextPage: z.number(),
  totalCount: z.number(),
});
export type UsersMeClipsResponse = z.infer<typeof UsersMeClipsResponse>;
export type ClipSchema = z.infer<typeof ClipSchema>;

// POST /3.0/reports/{type}/{reportId}/clip
// DELETE /3.0/reports/{type}/{reportId}/clip
export const ClipCountResponse = z.object({
  clipsCount: z.number(),
});

// POST /3.0/columns/{columnId}/clip
// DELETE /3.0/columns/{columnId}/clip
// MEMO:返却は空オブジェクトだが、型を定義しておく
// 空オブジェクトでなく、reportと同じくclipCountを返却するようにする
export const ClipColumnResponse = z.object({});

export type ClipCountResponse = z.infer<typeof ClipCountResponse>;
export type ClipColumnResponse = z.infer<typeof ClipColumnResponse>;
